import { useQuery } from '@apollo/client';
import Cookies from 'js-cookie';
import React, { useState, useEffect } from 'react';

import styled from 'styled-components/macro';

import HtmlHeader from 'Components/HtmlHead';
import RegistrationForm from 'Components/RegistrationForm';
import queryString from 'query-string';
import { GET_SALES_BY_UNIVERSE, LANDING_PAGE } from 'Pages/Landing/query';
import { IconClose } from 'Ui/Icons/';
import {
  landingPage,
  landingPageVariables,
} from 'Pages/Landing/__generated__/landingPage';
import { getPageView } from 'Libs/GA4/common';

import { LogoCarousel } from 'Ui/LogoCarousel';
import { PageContainer, theme } from 'Ui';
import JoinBazarchic from 'Ui/JoinBazarchic';
import {
  getSalesByUnivers,
  getSalesByUniversVariables,
} from './__generated__/getSalesByUnivers';
import fonts from '../../Fonts/';
import { setCookie } from 'Utils/cookie';
import { useLocation, useParams } from 'react-router-dom';

const Page = styled.div<{ desktop: any; tablet: any }>`
  min-height: 80vh;
  padding: 2rem 0;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #000;
  /* &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${(props) => props.desktop});
    background-size: cover;
    background-position: center;
    @media screen and (max-width: 768px) {
      background-image: url(${(props) => props.tablet});
    }
  } */
  background-image: url(${(props) => props.desktop});
  background-size: cover;
  background-position: center;
  @media screen and (max-width: 768px) {
    background-image: url(${(props) => props.tablet});
  }

  @media screen and (min-width: 768px) {
    min-height: calc(100vh - 93px);
    /* height: 90vh; */
    margin: 0;
    background-position-x: center;
  }

  @media screen and (min-width: 1250px) {
    height: 100%;
    /* height: 90vh; */
  }
`;

const StyledForm = styled.div`
  padding: 1.5rem;
  background-color: rgba(255, 255, 255, 0.9);
  width: 338px;
  border-radius: 25px;
  flex: none;
  @media screen and (max-width: 768px) {
    margin-left: 2rem;
  }
`;

const LandingMain = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  @media screen and (min-width: 768px) {
    width: 96.5rem;
    margin: 0 auto;
    flex-direction: row;
    position: relative;
    align-items: center;
    height: 100%;
  }
`;

const ContentTitle = styled.div`
  margin: 3.4rem 0rem;
  align-self: center;
  color: #fff;
  width: 100%;
  font-size: 2.2rem;
  line-height: 2.9rem;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
`;

// const Title = styled.div`
//   font-weight: 600;
// `;

const TitleForm = styled.h1`
  @font-face {
    font-family: 'granville-bold';
    src: url(${fonts.granvileBold}) format('opentype');
    font-weight: 400;
    font-style: normal;
  }
  color: #000;
  font-weight: 700;
  font-family: 'granville-bold';
  color: ${theme.light.colors.purple};
  font-size: 5rem;
  text-align: center;
  margin: 1rem 0rem 1.3rem 0rem;
`;

const SubTitle = styled.div<{ bold: boolean; italic: boolean }>`
  font-style: ${(props) => (props.italic ? 'italic' : 'normal')};
  font-weight: ${(props) => (props.bold ? '800' : 'normal')};
`;

const Welcome = styled.div`
  position: fixed;
  z-index: 100;
  width: 100%;
  left: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 60%);
  color: #fff;
  text-align: left;
  font-size: 1.6rem;
  font-family: 'Open sans';
  line-height: 2.4rem;
  padding: 1rem 0rem 1rem 1rem;
  p {
    width: 90%;
    font-weight: 400;
    span {
      font-weight: 700;
    }
  }
  .hideBannerWelecome {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 10px;
  }
  @media screen and (min-width: 768px) {
    text-align: center;
  }
`;

const Description = styled.div`
  font-size: 12px;
  font-family: 'Montserrat', 'os-regular', 'Arial', sans-serif;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }
  u {
    text-decoration: underline;
  }
  p {
    line-height: 1.8rem;
  }
`;

export default () => {
  const configCookie = { domain: '.bazarchic.com', expires: 30, secure: true };
  const { action } = useParams();
  const location = useLocation();
  const [shohBannerWelcome, setShohBannerWelcome] = useState(
    !Cookies.get('hideBannerWelcome')
  );

  const landingPageUrlName = action || '';

  const query = queryString.parse(location.search) as {
    site: string;
  };

  if (query && query.site) {
    Cookies.set('site', query.site, configCookie);
  }

  const { data } = useQuery<landingPage, landingPageVariables>(LANDING_PAGE, {
    variables: {
      landingPageUrlName: landingPageUrlName,
    },
  });

  const dataLanding = data && data.landingPage;
  const universeDescription = dataLanding && dataLanding.descriptionUniverse;
  const backroundImage = dataLanding && dataLanding.backGroundImage;
  const title = dataLanding && dataLanding.metaTitle;
  const catchText = dataLanding && dataLanding.catchText;
  const universe = dataLanding && dataLanding.univers;
  const [logos, setLogos] = useState(universe);

  // const universeToString = universe.toString()
  const canonical = `${window.location.host}${window.location.pathname}`;
  const bannerWelcome = () => {
    // Cookie.set('hideBannerWelcome', 'true', configCookie);
    const objectCookie = {
      path: '/',
      expires: 180,
      secure: true,
      name: 'hideBannerWelcome',
      value: 'true',
    };
    setCookie(objectCookie);
    setShohBannerWelcome(false);
  };

  useEffect(() => {
    const checkUniverse = universe == '' ? 'ACCUEIL' : universe;
    setLogos(String(checkUniverse).toUpperCase());
  }, [universe, dataLanding]);

  const { data: salesLogo } = useQuery<
    getSalesByUnivers,
    getSalesByUniversVariables
  >(GET_SALES_BY_UNIVERSE, {
    variables: {
      universe: logos,
    },
  });

  const salesLogoList =
    salesLogo && salesLogo.salesByUniverse && salesLogo.salesByUniverse.edges;

  useEffect(() => {
    getPageView(window.location.pathname, window.location.href);
  }, []);

  return (
    <>
      <Page
        tablet={backroundImage && backroundImage.tablet}
        desktop={backroundImage && backroundImage.desktop}
      >
        <HtmlHeader title={title} noIndex={true} canonical={canonical} />
        <LandingMain>
          <StyledForm>
            <TitleForm>Inscription</TitleForm>
            <RegistrationForm />
          </StyledForm>
          <ContentTitle>
            {catchText &&
              catchText.map((subTile, index) => (
                <SubTitle
                  key={index}
                  bold={subTile.bold}
                  italic={subTile.italic}
                >
                  {subTile.text}
                </SubTitle>
              ))}
          </ContentTitle>
        </LandingMain>
        {shohBannerWelcome && (
          <Welcome>
            <p>
              <span>10€ offerts</span> sur votre 1<sup>ère</sup> commande avec
              le code «BIENVENUE»
            </p>
            <div className="hideBannerWelecome" onClick={() => bannerWelcome()}>
              <IconClose />
            </div>
          </Welcome>
        )}
      </Page>
      <PageContainer>
        {salesLogo &&
          salesLogo.salesByUniverse &&
          salesLogo.salesByUniverse.edges &&
          salesLogo.salesByUniverse.edges.length !== 0 && (
            <LogoCarousel logo={salesLogoList} title="Nos ventes en cours" />
          )}
        <JoinBazarchic />
      </PageContainer>
      <PageContainer>
        <Description
          dangerouslySetInnerHTML={{
            __html: universeDescription || '',
          }}
        ></Description>
      </PageContainer>
    </>
  );
};
